import { render } from "./TrainingTargetListModel.vue?vue&type=template&id=44e6b97c&ts=true"
import script from "./TrainingTargetListModel.vue?vue&type=script&lang=ts"
export * from "./TrainingTargetListModel.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__